export * from './alias-data-store';

import * as _selectors from './selectors';
export const aliasSelectors = _selectors;
